export const Companies = [
	{
		name: "Hobson Wealth",
		code: "hwp",
		description:
			"Hobson Wealth is a leading private wealth advisory team with offices throughout New Zealand. They are Kiwi owned and operated and enjoy a strategic relationship with the Macquarie Group.",
		img: "images/2023-images/logos/HWP.png",
	},
	{
		name: "Simplicity",
		code: "simplicity",
		description:
			"Simplicity NZ is a non-profit KiwiSaver and investment fund manager, offering low fees and ethical investing to help Kiwis grow their wealth with simple, responsible options.",
		img: "images/2023-images/logos/simplicity.png",
		link: "https://simplicity.kiwi/",
	},
	{
		name: "Craigs Investment Partners",
		code: "cip",
		description:
			"Craigs Investment Partners is one of New Zealand’s leading investment advisory firms. They offer investment solutions to private, corporate and institutional clients with offices throughout New Zealand.",
		img: "images/2023-images/logos/CIP.png",
		link: "https://craigsip.com/",
	}
];